<template>
    <div class="registersuccess">
        <md-result-page img-url="/static/icon/registersuccess.png" text="Welcome to the"></md-result-page>
        <div class="registersuccess-btns">
            <md-button inline @click="download_app">Download app</md-button>
            <md-button type="primary" icon="edit" inline @click="go_login">Go to login</md-button>
        </div>
    </div>
</template>

<script>
import { getsiteconfig } from '@/request/api'
export default {
    name: 'registersuccess',
    data() {
        return {
            buttons: [
                {
                    text: 'Download app',
                    handler() {
                        Toast.succeed('Download app')
                    },
                },
                {
                    text: 'Go to login',
                    type: 'primary',
                    handler() {
                        this.$router.push('/login')
                    },
                },
            ],
            app_download_url: ""
        }
    },
    created() {
        getsiteconfig().then(res=>{
            if(res.code === 200) {
                this.app_download_url = res.data.app_download_url;
            }
        })
    },
    methods: {
        download_app() {
            window.location.href = this.app_download_url;
        },
        go_login() {
            window.location.href = this.app_download_url;
        }
    }
}
</script>

<style scoped>
.registersuccess {
    margin-top: 2rem;
}

.registersuccess-btns {
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/registersuccess.vue